export const COOKIE_CONSENT_STORAGE_KEY = "maxfit:cookies-notice";
export const COOKIE_CONSENT_VERSION = "2026-05-02";
export const COOKIE_CONSENT_EVENT = "maxfit:cookie-consent-change";
export const COOKIE_SETTINGS_EVENT = "maxfit:cookie-settings-open";

const baseConsent = {
  version: COOKIE_CONSENT_VERSION,
  necessary: true,
  analytics: false,
  speedInsights: false,
  marketing: false,
  decided: false,
  source: "unset",
  updatedAt: "",
};

export const normalizeCookieConsent = (value) => {
  const next = {
    ...baseConsent,
    ...(value && typeof value === "object" ? value : {}),
  };
  next.version = COOKIE_CONSENT_VERSION;
  next.necessary = true;
  next.analytics = Boolean(next.analytics);
  next.speedInsights = Boolean(next.speedInsights);
  next.marketing = false;
  next.decided = Boolean(next.decided);
  next.source = String(next.source || "custom");
  next.updatedAt = String(next.updatedAt || "");
  return next;
};

export const readCookieConsent = () => {
  if (typeof window === "undefined") return normalizeCookieConsent();
  try {
    const raw = window.localStorage.getItem(COOKIE_CONSENT_STORAGE_KEY);
    if (!raw) return normalizeCookieConsent();
    return normalizeCookieConsent(JSON.parse(raw));
  } catch {
    return normalizeCookieConsent();
  }
};

export const hasCookieDecision = () => {
  const consent = readCookieConsent();
  return consent.version === COOKIE_CONSENT_VERSION && consent.decided;
};

export const saveCookieConsent = (value) => {
  if (typeof window === "undefined") return normalizeCookieConsent(value);
  const next = normalizeCookieConsent({
    ...value,
    decided: true,
    updatedAt: new Date().toISOString(),
  });
  window.localStorage.setItem(COOKIE_CONSENT_STORAGE_KEY, JSON.stringify(next));
  window.dispatchEvent(new CustomEvent(COOKIE_CONSENT_EVENT, { detail: next }));
  return next;
};

export const openCookieSettings = () => {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(COOKIE_SETTINGS_EVENT));
};

